unit SystemCostGroupsSetup;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.Buttons, Vcl.Controls, WEBLib.ExtCtrls,
  Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.DBCtrls, VCL.TMSFNCTypes,
  VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCDataGridDatabaseAdapter, VCL.TMSFNCCustomControl, VCL.TMSFNCDataGrid,
  Data.DB, WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Client,
  VCL.TMSFNCGridCell, VCL.TMSFNCGridOptions, VCL.TMSFNCCustomGrid,
  VCL.TMSFNCGridDatabaseAdapter, VCL.TMSFNCCustomScrollControl,
  VCL.TMSFNCGridData, VCL.TMSFNCGrid;

type
  TFrmCostGroupsSetup = class(TForm)
    WebPanel5: TPanel;
    WebPanel4: TPanel;
    WebLabel6: TLabel;
    pnlButtons: TPanel;
    WebSpeedButton1: TSpeedButton;
    WebSpeedButton2: TSpeedButton;
    WebSpeedButton3: TSpeedButton;
    WebSpeedButton4: TSpeedButton;
    WebSpeedButton5: TSpeedButton;
    wdsCostGroups: TXDataWebDataSet;
    dsCostGroups: TDataSource;
    wdsCostDetails: TXDataWebDataSet;
    dsCostDetails: TDataSource;
    WebPanel1: TPanel;
    WebLabel1: TLabel;
    wcCostingDetails: TXDataWebClient;
    wdsCostDetailsCostGroupMo: TIntegerField;
    wdsCostDetailsFleetType: TIntegerField;
    wdsCostDetailsValueType: TIntegerField;
    wdsCostDetailsSystemType: TIntegerField;
    wdsCostDetailsGLCode: TStringField;
    wsbtnPost: TSpeedButton;
    wsbtnClose: TSpeedButton;
    tmsfncCostDetails: TTMSFNCGrid;
    dbaCostDetails: TTMSFNCGridDatabaseAdapter;
    wcCostGroups: TXDataWebClient;
    wdsCostGroupsCode: TIntegerField;
    wdsCostGroupsSuspended: TBooleanField;
    wpBottom: TPanel;
    lPageCountMax: TLabel;
    btnPageLeft: TSpeedButton;
    btnPageRight: TSpeedButton;
    ePageCount: TEdit;
    eMaxPageCount: TEdit;
    wcPageCount: TXDataWebClient;
    wdsCostGroupsDescription: TStringField;
    WebMessageDlg1: TMessageDlg;
    wdsCostDetailscostgroupsdetail_Auto: TIntegerField;
    dbedtCostGrooup: TDBEdit;
    dbcbxSuspended: TDBCheckBox;
    procedure WebSpeedButton1Click(Sender: TObject);
    procedure WebSpeedButton2Click(Sender: TObject);
    procedure WebSpeedButton3Click(Sender: TObject);
    procedure WebSpeedButton4Click(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure wsbtnCloseClick(Sender: TObject);
    procedure wsbtnPostClick(Sender: TObject);
    procedure ePageCountExit(Sender: TObject);
    procedure btnPageRightClick(Sender: TObject);
    procedure btnPageLeftClick(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
    procedure tmsfncCostDetailsGetCellLayout(Sender: TObject; ACol, ARow: Integer;
      ALayout: TTMSFNCGridCellLayout; ACellState: TTMSFNCGridCellState);
    procedure tmsfncCostDetailsCellClick(Sender: TObject; ACol, ARow: Integer);
    procedure WebSpeedButton5Click(Sender: TObject);
  private
    { Private declarations }
    iPageCount, iMaxPageCount : Integer;

    Procedure LoadData(iPrim : Integer);
    Procedure LoadCostGroupView;
    Procedure SetScreenSize(bGrid : Boolean);
  public
    { Public declarations }
    iState : Integer;
    iPK : integer;
    sCostGroup : String;
    bSuspended : Boolean;
  protected procedure LoadDFMValues; override; end;

  TTMSFNCGridDataBaseAdapterOpen = class(TTMSFNCGridDatabaseAdapter);
var
  FrmCostGroupsSetup: TFrmCostGroupsSetup;

implementation

{$R *.dfm}

uses
  stfmssystem.connection , share.system.classes , share.common, SystemCostGroupDetailEdit;

procedure TFrmCostGroupsSetup.btnPageLeftClick(Sender: TObject);
begin
  if iPageCount - 1 >= 1 then
    begin
      iPageCount := iPageCount - 1;
      LoadData(0);
    end;
end;

procedure TFrmCostGroupsSetup.btnPageRightClick(Sender: TObject);
begin
  if iPageCount + 1 <= iMaxPageCount then
    begin
      iPageCount := iPageCount + 1;
      LoadData(0);

    end;
end;

procedure TFrmCostGroupsSetup.ePageCountExit(Sender: TObject);
begin
  if (StrToInt(ePageCount.Text) > 0) AND (StrToInt(ePageCount.Text) < iMaxPageCount)  then
    begin
      iPageCount := StrToInt(ePageCount.Text);
      LoadData(0);
    end
  else
    begin
      iPageCount := iMaxPageCount;
      LoadCostGroupView;
      ePageCount.Text := IntToStr(iPageCount);
    end;

end;

procedure TFrmCostGroupsSetup.LoadCostGroupView;
   procedure OnResultGroups(Response : TXDataClientResponse);
    begin
      wdsCostGroups.Close;
      wdsCostGroups.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsCostGroups.Open;
    end;
begin
 // wcCostGroups.RawInvoke('IstfmsSystemService.Get_CostGroups_View',[iPrim,0],@OnResultGroups);   ///////
end;

procedure TFrmCostGroupsSetup.LoadData(iPrim : Integer);
  procedure OnResultGroups(Response : TXDataClientResponse);
    begin
      console.log(wdsCostGroups);
      wdsCostGroups.Close;
      wdsCostGroups.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsCostGroups.Open;

    end;

    procedure OnResult(Response : TXDataClientResponse);
    begin
      wdsCostDetails.Close;
      wdsCostDetails.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsCostDetails.Open;

      wcCostGroups.RawInvoke('IstfmsSystemService.Get_CostGroups_View',[iPrim,0],@OnResultGroups);
    end;

  procedure OnResultCount(Response : TXDataClientResponse);
    begin
      iMaxPageCount := Integer(TJSObject(Response.Result)['value']);
      eMaxPageCount.Text := IntToStr(iMaxPageCount);

      wcCostingDetails.RawInvoke('IstfmsSystemService.Get_CostGroupDetails_View', [0,iPageCount], @OnResult);   ////
    end;

begin
  wcPageCount.RawInvoke('IstfmsSystemService.Get_CostGroupDetails_MaxPageCount', [], @OnResultCount);
  ePageCount.Text := IntToStr(iPageCount);
end;

procedure TFrmCostGroupsSetup.SetScreenSize(bGrid: Boolean);
begin

  if bGrid = True then
    begin
      tmsfncCostDetails.Visible := True;
      pnlButtons.Visible := True;

    end
  else
    begin
      tmsfncCostDetails.Visible := False;
      pnlButtons.Visible := False;

    end;

end;

procedure TFrmCostGroupsSetup.tmsfncCostDetailsCellClick(Sender: TObject; ACol,
  ARow: Integer);
  var
    newform : TfrmSystemCostGroupDetailEdit;

  procedure OnResult(Value : TModalResult);
    begin
      if Value = mrYes then
        begin
          wcCostingDetails.RawInvoke('IstfmsSystemService.Put_CostGroupDetail_Delete',[GetAdapterKey(dbaCostDetails,7,ARow)]);
        end;

      LoadData(0);
    end;

    procedure AfterShowModal(AValue: TModalResult);
      begin
        newform.Free;
      end;
begin
  if ACol = 5 then
    begin
      //edit
      newform := TfrmSystemCostGroupDetailEdit.CreateNew;
      newform.Popup := true;
      newform.PopupOpacity := 0.2;
      newform.iState2 := 2;
      newform.iPrim := GetAdapterKey(dbaCostDetails,7,ARow);
      newform.Showmodal(@AfterShowModal);;
    end;
  if ACol = 6 then
    begin
      //Delete

      WebMessageDlg1.ShowDialog('Do you want to delete this record?', WEBLib.Dialogs.mtWarning,[mbYes, mbNo], @OnResult);
    end;

end;

procedure TFrmCostGroupsSetup.tmsfncCostDetailsGetCellLayout(Sender: TObject; ACol,
  ARow: Integer; ALayout: TTMSFNCGridCellLayout;
  ACellState: TTMSFNCGridCellState);

  var
    ilRow,
    ilCol,
    ar : Integer;
    d : TTMSFNCGridDataBaseAdapterOpen;
    fName : TField;
    Bitmap : TTMSFNCBitmap;

begin
  ilRow := ARow;

  If (ilRow <= tmsfncCostDetails.FixedRows - 1) then
    Exit;

  ilCol := ACol;

  If ilCol = 5 then
    begin
      d := TTMSFNCGridDataBaseAdapterOpen(dbaCostDetails);
      if d.CheckDataSet then
        begin
          ar := d.DataLink.ActiveRecord;
          try
            d.SetActiveRecord(ilRow);
            fName := d.FieldAtColumn[1];
            if Assigned(fName) then
              begin
                If Trim(fName.AsString) <> '' then
                  begin
                    Bitmap := TTMSFNCBitmap.Create;
                    Bitmap.LoadFromURL('images/buttons/edit.svg');
                    tmsfncCostDetails.AddBitmap(5,ilRow,Bitmap);
                    Bitmap.Free;
                  end;
              end;
          finally
            d.DataLink.ActiveRecord := ar;
          end;
        end;
    end;

    If ilCol = 6 then
    begin
      d := TTMSFNCGridDataBaseAdapterOpen(dbaCostDetails);
      if d.CheckDataSet then
        begin
          ar := d.DataLink.ActiveRecord;
          try
            d.SetActiveRecord(ilRow);
            fName := d.FieldAtColumn[1];
            if Assigned(fName) then
              begin
                If Trim(fName.AsString) <> '' then
                  begin
                    Bitmap := TTMSFNCBitmap.Create;
                    Bitmap.LoadFromURL('images/buttons/delete.svg');
                    tmsfncCostDetails.AddBitmap(6,ilRow,Bitmap);
                    Bitmap.Free;
                  end;
              end;
          finally
            d.DataLink.ActiveRecord := ar;
          end;
        end;
    end;
end;

procedure TFrmCostGroupsSetup.WebFormClose(Sender: TObject;
  var Action: TCloseAction);
begin
  // Action := caFree;
end;

procedure TFrmCostGroupsSetup.WebFormShow(Sender: TObject);

begin
  If iState = 1 then
    begin
      LoadData(0);
    end;
  If iState = 2 then
    begin
      LoadData(iPK);

    end;
  iPageCount := 1;

  SetScreenSize(True);


end;

procedure TFrmCostGroupsSetup.WebSpeedButton1Click(Sender: TObject);
begin
  wdsCostDetails.First;
end;

procedure TFrmCostGroupsSetup.WebSpeedButton2Click(Sender: TObject);
begin
  wdsCostDetails.Prior;
end;

procedure TFrmCostGroupsSetup.WebSpeedButton3Click(Sender: TObject);
begin
  wdsCostDetails.Next;
end;

procedure TFrmCostGroupsSetup.WebSpeedButton4Click(Sender: TObject);
begin
  wdsCostDetails.Last;
end;

procedure TFrmCostGroupsSetup.WebSpeedButton5Click(Sender: TObject);
var
  newform : TfrmSystemCostGroupDetailEdit;

  procedure AfterShowModal(AValue: TModalResult);
  begin
    newform.Free;
  end;
begin
  newform := TfrmSystemCostGroupDetailEdit.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.iState2 := 1;
  newform.iPrim := 0;
  newform.Showmodal(@AfterShowModal);;
end;

procedure TFrmCostGroupsSetup.wsbtnCloseClick(Sender: TObject);
begin
  Close;
end;

procedure TFrmCostGroupsSetup.wsbtnPostClick(Sender: TObject);
  procedure OnSuccess2(Response : TXDataClientResponse);
    begin
      wdsCostGroups.Cancel;
      Close;
    end;
  procedure OnSuccessInsert(Response : TXDataClientResponse);
    var
      Form : TSysCostGroupsView;
    begin
      Close;
    end;
  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      Close;
    end;
  procedure OnError(Error: TXDataClientError);
    begin
      wdsCostDetails.Cancel;
      ShowMessage(Error.ErrorMessage);
    end;

begin
  Case iState of
    1 : begin
          Console.log(GetJsonFromDataSet(wdsCostGroups));
          wcCostingDetails.RawInvoke('IstfmsSystemService.Put_CostGroupType_Insert', [GetJsonFromDataSet(wdsCostGroups)],@OnSuccessInsert, @OnError);
        end;
    2 : begin
          //Console.log(GetJsonFromDataSet(wdsAutomail));

          wcCostingDetails.RawInvoke('IstfmsSystemService.Put_CostGroupType_Edit', [GetJsonFromDataSet(wdsCostGroups)],@OnSuccess, @OnError)

        end;
    end;
end;

procedure TFrmCostGroupsSetup.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel5 := TPanel.Create(Self);
  wsbtnPost := TSpeedButton.Create(Self);
  wsbtnClose := TSpeedButton.Create(Self);
  WebPanel4 := TPanel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  dbedtCostGrooup := TDBEdit.Create(Self);
  dbcbxSuspended := TDBCheckBox.Create(Self);
  pnlButtons := TPanel.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  WebSpeedButton3 := TSpeedButton.Create(Self);
  WebSpeedButton4 := TSpeedButton.Create(Self);
  WebSpeedButton5 := TSpeedButton.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  tmsfncCostDetails := TTMSFNCGrid.Create(Self);
  dbaCostDetails := TTMSFNCGridDatabaseAdapter.Create(Self);
  WebMessageDlg1 := TMessageDlg.Create(Self);
  wpBottom := TPanel.Create(Self);
  lPageCountMax := TLabel.Create(Self);
  btnPageLeft := TSpeedButton.Create(Self);
  btnPageRight := TSpeedButton.Create(Self);
  ePageCount := TEdit.Create(Self);
  eMaxPageCount := TEdit.Create(Self);
  wdsCostGroups := TXDataWebDataSet.Create(Self);
  wdsCostGroupsCode := TIntegerField.Create(Self);
  wdsCostGroupsSuspended := TBooleanField.Create(Self);
  wdsCostGroupsDescription := TStringField.Create(Self);
  dsCostGroups := TDataSource.Create(Self);
  wdsCostDetails := TXDataWebDataSet.Create(Self);
  wdsCostDetailsCostGroupMo := TIntegerField.Create(Self);
  wdsCostDetailsFleetType := TIntegerField.Create(Self);
  wdsCostDetailsValueType := TIntegerField.Create(Self);
  wdsCostDetailsSystemType := TIntegerField.Create(Self);
  wdsCostDetailsGLCode := TStringField.Create(Self);
  wdsCostDetailscostgroupsdetail_Auto := TIntegerField.Create(Self);
  dsCostDetails := TDataSource.Create(Self);
  wcCostingDetails := TXDataWebClient.Create(Self);
  wcCostGroups := TXDataWebClient.Create(Self);
  wcPageCount := TXDataWebClient.Create(Self);

  WebPanel5.BeforeLoadDFMValues;
  wsbtnPost.BeforeLoadDFMValues;
  wsbtnClose.BeforeLoadDFMValues;
  WebPanel4.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  dbedtCostGrooup.BeforeLoadDFMValues;
  dbcbxSuspended.BeforeLoadDFMValues;
  pnlButtons.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  WebSpeedButton3.BeforeLoadDFMValues;
  WebSpeedButton4.BeforeLoadDFMValues;
  WebSpeedButton5.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  tmsfncCostDetails.BeforeLoadDFMValues;
  dbaCostDetails.BeforeLoadDFMValues;
  WebMessageDlg1.BeforeLoadDFMValues;
  wpBottom.BeforeLoadDFMValues;
  lPageCountMax.BeforeLoadDFMValues;
  btnPageLeft.BeforeLoadDFMValues;
  btnPageRight.BeforeLoadDFMValues;
  ePageCount.BeforeLoadDFMValues;
  eMaxPageCount.BeforeLoadDFMValues;
  wdsCostGroups.BeforeLoadDFMValues;
  wdsCostGroupsCode.BeforeLoadDFMValues;
  wdsCostGroupsSuspended.BeforeLoadDFMValues;
  wdsCostGroupsDescription.BeforeLoadDFMValues;
  dsCostGroups.BeforeLoadDFMValues;
  wdsCostDetails.BeforeLoadDFMValues;
  wdsCostDetailsCostGroupMo.BeforeLoadDFMValues;
  wdsCostDetailsFleetType.BeforeLoadDFMValues;
  wdsCostDetailsValueType.BeforeLoadDFMValues;
  wdsCostDetailsSystemType.BeforeLoadDFMValues;
  wdsCostDetailsGLCode.BeforeLoadDFMValues;
  wdsCostDetailscostgroupsdetail_Auto.BeforeLoadDFMValues;
  dsCostDetails.BeforeLoadDFMValues;
  wcCostingDetails.BeforeLoadDFMValues;
  wcCostGroups.BeforeLoadDFMValues;
  wcPageCount.BeforeLoadDFMValues;
  try
    Name := 'FrmCostGroupsSetup';
    Width := 1001;
    Height := 634;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -12;
    Font.Name := '@Malgun Gothic';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnClose', 'WebFormClose');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel5.SetParentComponent(Self);
    WebPanel5.Name := 'WebPanel5';
    WebPanel5.Left := 0;
    WebPanel5.Top := 60;
    WebPanel5.Width := 1001;
    WebPanel5.Height := 60;
    WebPanel5.Align := alTop;
    WebPanel5.BorderStyle := bsNone;
    WebPanel5.ChildOrder := 2;
    WebPanel5.Color := clSilver;
    WebPanel5.TabOrder := 0;
    wsbtnPost.SetParentComponent(WebPanel5);
    wsbtnPost.Name := 'wsbtnPost';
    wsbtnPost.Left := 14;
    wsbtnPost.Top := 13;
    wsbtnPost.Width := 193;
    wsbtnPost.Height := 41;
    wsbtnPost.Caption := 'Post';
    wsbtnPost.Color := clNone;
    wsbtnPost.HeightPercent := 100.000000000000000000;
    wsbtnPost.TabOrder := 0;
    wsbtnPost.WidthPercent := 100.000000000000000000;
    SetEvent(wsbtnPost, Self, 'OnClick', 'wsbtnPostClick');
    wsbtnClose.SetParentComponent(WebPanel5);
    wsbtnClose.Name := 'wsbtnClose';
    wsbtnClose.Left := 213;
    wsbtnClose.Top := 13;
    wsbtnClose.Width := 185;
    wsbtnClose.Height := 41;
    wsbtnClose.Caption := 'Close';
    wsbtnClose.Color := clNone;
    wsbtnClose.HeightPercent := 100.000000000000000000;
    wsbtnClose.TabOrder := 1;
    wsbtnClose.WidthPercent := 100.000000000000000000;
    SetEvent(wsbtnClose, Self, 'OnClick', 'wsbtnCloseClick');
    WebPanel4.SetParentComponent(Self);
    WebPanel4.Name := 'WebPanel4';
    WebPanel4.Left := 0;
    WebPanel4.Top := 120;
    WebPanel4.Width := 1001;
    WebPanel4.Height := 60;
    WebPanel4.Align := alTop;
    WebPanel4.ChildOrder := 5;
    WebPanel4.TabOrder := 1;
    WebLabel6.SetParentComponent(WebPanel4);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 24;
    WebLabel6.Top := 4;
    WebLabel6.Width := 81;
    WebLabel6.Height := 15;
    WebLabel6.Caption := 'Costing Group:';
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.WidthPercent := 100.000000000000000000;
    dbedtCostGrooup.SetParentComponent(WebPanel4);
    dbedtCostGrooup.Name := 'dbedtCostGrooup';
    dbedtCostGrooup.Left := 24;
    dbedtCostGrooup.Top := 25;
    dbedtCostGrooup.Width := 161;
    dbedtCostGrooup.Height := 22;
    dbedtCostGrooup.ChildOrder := 3;
    dbedtCostGrooup.HeightPercent := 100.000000000000000000;
    dbedtCostGrooup.WidthPercent := 100.000000000000000000;
    dbedtCostGrooup.DataField := 'Description';
    dbedtCostGrooup.DataSource := dsCostGroups;
    dbcbxSuspended.SetParentComponent(WebPanel4);
    dbcbxSuspended.Name := 'dbcbxSuspended';
    dbcbxSuspended.Left := 213;
    dbcbxSuspended.Top := 24;
    dbcbxSuspended.Width := 113;
    dbcbxSuspended.Height := 22;
    dbcbxSuspended.Caption := 'Suspended';
    dbcbxSuspended.ChildOrder := 4;
    dbcbxSuspended.HeightPercent := 100.000000000000000000;
    dbcbxSuspended.WidthPercent := 100.000000000000000000;
    dbcbxSuspended.DataField := 'Suspended';
    dbcbxSuspended.DataSource := dsCostGroups;
    dbcbxSuspended.ValueChecked := 'True';
    dbcbxSuspended.ValueUnChecked := 'False';
    pnlButtons.SetParentComponent(Self);
    pnlButtons.Name := 'pnlButtons';
    pnlButtons.Left := 0;
    pnlButtons.Top := 180;
    pnlButtons.Width := 1001;
    pnlButtons.Height := 60;
    pnlButtons.Align := alTop;
    pnlButtons.BorderStyle := bsNone;
    pnlButtons.ChildOrder := 1;
    pnlButtons.Color := clSilver;
    pnlButtons.TabOrder := 2;
    WebSpeedButton1.SetParentComponent(pnlButtons);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 9;
    WebSpeedButton1.Top := 11;
    WebSpeedButton1.Width := 45;
    WebSpeedButton1.Height := 43;
    WebSpeedButton1.Caption := '<<';
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.TabOrder := 0;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton1, Self, 'OnClick', 'WebSpeedButton1Click');
    WebSpeedButton2.SetParentComponent(pnlButtons);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 60;
    WebSpeedButton2.Top := 11;
    WebSpeedButton2.Width := 45;
    WebSpeedButton2.Height := 43;
    WebSpeedButton2.Caption := '<';
    WebSpeedButton2.Color := clNone;
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.TabOrder := 1;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton2, Self, 'OnClick', 'WebSpeedButton2Click');
    WebSpeedButton3.SetParentComponent(pnlButtons);
    WebSpeedButton3.Name := 'WebSpeedButton3';
    WebSpeedButton3.Left := 111;
    WebSpeedButton3.Top := 11;
    WebSpeedButton3.Width := 45;
    WebSpeedButton3.Height := 43;
    WebSpeedButton3.Caption := '>';
    WebSpeedButton3.Color := clNone;
    WebSpeedButton3.HeightPercent := 100.000000000000000000;
    WebSpeedButton3.TabOrder := 2;
    WebSpeedButton3.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton3, Self, 'OnClick', 'WebSpeedButton3Click');
    WebSpeedButton4.SetParentComponent(pnlButtons);
    WebSpeedButton4.Name := 'WebSpeedButton4';
    WebSpeedButton4.Left := 162;
    WebSpeedButton4.Top := 11;
    WebSpeedButton4.Width := 45;
    WebSpeedButton4.Height := 43;
    WebSpeedButton4.Caption := '>>';
    WebSpeedButton4.Color := clNone;
    WebSpeedButton4.HeightPercent := 100.000000000000000000;
    WebSpeedButton4.TabOrder := 3;
    WebSpeedButton4.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton4, Self, 'OnClick', 'WebSpeedButton4Click');
    WebSpeedButton5.SetParentComponent(pnlButtons);
    WebSpeedButton5.Name := 'WebSpeedButton5';
    WebSpeedButton5.Left := 213;
    WebSpeedButton5.Top := 11;
    WebSpeedButton5.Width := 45;
    WebSpeedButton5.Height := 43;
    WebSpeedButton5.Caption := '+';
    WebSpeedButton5.Color := clNone;
    WebSpeedButton5.HeightPercent := 100.000000000000000000;
    WebSpeedButton5.TabOrder := 4;
    WebSpeedButton5.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton5, Self, 'OnClick', 'WebSpeedButton5Click');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 1001;
    WebPanel1.Height := 60;
    WebPanel1.Align := alTop;
    WebPanel1.ChildOrder := 5;
    WebPanel1.TabOrder := 3;
    WebLabel1.SetParentComponent(WebPanel1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 0;
    WebLabel1.Top := 0;
    WebLabel1.Width := 1001;
    WebLabel1.Height := 25;
    WebLabel1.Align := alTop;
    WebLabel1.Alignment := taCenter;
    WebLabel1.Caption := 'Costing Groups';
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clWindowText;
    WebLabel1.Font.Height := -18;
    WebLabel1.Font.Name := 'Segoe UI';
    WebLabel1.Font.Style := [fsBold];
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthPercent := 100.000000000000000000;
    tmsfncCostDetails.SetParentComponent(Self);
    tmsfncCostDetails.Name := 'tmsfncCostDetails';
    tmsfncCostDetails.Left := 0;
    tmsfncCostDetails.Top := 240;
    tmsfncCostDetails.Width := 1001;
    tmsfncCostDetails.Height := 353;
    tmsfncCostDetails.Align := alLeft;
    tmsfncCostDetails.ParentDoubleBuffered := False;
    tmsfncCostDetails.DoubleBuffered := True;
    tmsfncCostDetails.TabOrder := 4;
    tmsfncCostDetails.DefaultRowHeight := 40.000000000000000000;
    tmsfncCostDetails.FixedColumns := 0;
    tmsfncCostDetails.ColumnCount := 8;
    tmsfncCostDetails.RowCount := 1;
    tmsfncCostDetails.Options.Bands.Enabled := True;
    tmsfncCostDetails.Options.Editing.CalcFormat := '%g';
    tmsfncCostDetails.Options.Grouping.CalcFormat := '%g';
    tmsfncCostDetails.Options.Grouping.GroupCountFormat := '(%d)';
    tmsfncCostDetails.Options.IO.XMLEncoding := 'ISO-8859-1';
    tmsfncCostDetails.Options.Mouse.ClickMargin := 0;
    tmsfncCostDetails.Options.Mouse.ColumnSizeMargin := 6;
    tmsfncCostDetails.Options.Mouse.RowSizeMargin := 6;
    tmsfncCostDetails.Adapter := dbaCostDetails;
    tmsfncCostDetails.Columns.Clear;
    with tmsfncCostDetails.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 0.000000000000000000;
    end;
    with tmsfncCostDetails.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 250.000000000000000000;
    end;
    with tmsfncCostDetails.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 100.000000000000000000;
    end;
    with tmsfncCostDetails.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 100.000000000000000000;
    end;
    with tmsfncCostDetails.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 90.000000000000000000;
    end;
    with tmsfncCostDetails.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 68.000000000000000000;
    end;
    with tmsfncCostDetails.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 68.000000000000000000;
    end;
    with tmsfncCostDetails.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 0.000000000000000000;
    end;
    tmsfncCostDetails.DefaultFont.Charset := DEFAULT_CHARSET;
    tmsfncCostDetails.DefaultFont.Color := clWindowText;
    tmsfncCostDetails.DefaultFont.Height := -11;
    tmsfncCostDetails.DefaultFont.Name := 'Segoe UI';
    tmsfncCostDetails.DefaultFont.Style := [];
    tmsfncCostDetails.TopRow := 1;
    tmsfncCostDetails.Appearance.FixedLayout.Fill.Color := 16380654;
    tmsfncCostDetails.Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    tmsfncCostDetails.Appearance.FixedLayout.Font.Color := 4539717;
    tmsfncCostDetails.Appearance.FixedLayout.Font.Height := -13;
    tmsfncCostDetails.Appearance.FixedLayout.Font.Name := 'Segoe UI';
    tmsfncCostDetails.Appearance.FixedLayout.Font.Style := [fsBold];
    tmsfncCostDetails.Appearance.NormalLayout.Fill.Color := 16578806;
    tmsfncCostDetails.Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    tmsfncCostDetails.Appearance.NormalLayout.Font.Color := 8026746;
    tmsfncCostDetails.Appearance.NormalLayout.Font.Height := -11;
    tmsfncCostDetails.Appearance.NormalLayout.Font.Name := 'Segoe UI';
    tmsfncCostDetails.Appearance.NormalLayout.Font.Style := [];
    tmsfncCostDetails.Appearance.GroupLayout.Fill.Color := 12817262;
    tmsfncCostDetails.Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    tmsfncCostDetails.Appearance.GroupLayout.Font.Color := clBlack;
    tmsfncCostDetails.Appearance.GroupLayout.Font.Height := -11;
    tmsfncCostDetails.Appearance.GroupLayout.Font.Name := 'Segoe UI';
    tmsfncCostDetails.Appearance.GroupLayout.Font.Style := [];
    tmsfncCostDetails.Appearance.SummaryLayout.Fill.Color := 14009785;
    tmsfncCostDetails.Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    tmsfncCostDetails.Appearance.SummaryLayout.Font.Color := clBlack;
    tmsfncCostDetails.Appearance.SummaryLayout.Font.Height := -11;
    tmsfncCostDetails.Appearance.SummaryLayout.Font.Name := 'Segoe UI';
    tmsfncCostDetails.Appearance.SummaryLayout.Font.Style := [];
    tmsfncCostDetails.Appearance.SelectedLayout.Fill.Color := 16441019;
    tmsfncCostDetails.Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    tmsfncCostDetails.Appearance.SelectedLayout.Font.Color := 4539717;
    tmsfncCostDetails.Appearance.SelectedLayout.Font.Height := -11;
    tmsfncCostDetails.Appearance.SelectedLayout.Font.Name := 'Segoe UI';
    tmsfncCostDetails.Appearance.SelectedLayout.Font.Style := [];
    tmsfncCostDetails.Appearance.FocusedLayout.Fill.Color := 16039284;
    tmsfncCostDetails.Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    tmsfncCostDetails.Appearance.FocusedLayout.Font.Color := 4539717;
    tmsfncCostDetails.Appearance.FocusedLayout.Font.Height := -11;
    tmsfncCostDetails.Appearance.FocusedLayout.Font.Name := 'Segoe UI';
    tmsfncCostDetails.Appearance.FocusedLayout.Font.Style := [];
    tmsfncCostDetails.Appearance.FixedSelectedLayout.Fill.Color := clLightsteelblue;
    tmsfncCostDetails.Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    tmsfncCostDetails.Appearance.FixedSelectedLayout.Font.Color := clBlack;
    tmsfncCostDetails.Appearance.FixedSelectedLayout.Font.Height := -11;
    tmsfncCostDetails.Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    tmsfncCostDetails.Appearance.FixedSelectedLayout.Font.Style := [];
    tmsfncCostDetails.Appearance.BandLayout.Fill.Color := 16711679;
    tmsfncCostDetails.Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    tmsfncCostDetails.Appearance.BandLayout.Font.Color := 8026746;
    tmsfncCostDetails.Appearance.BandLayout.Font.Height := -11;
    tmsfncCostDetails.Appearance.BandLayout.Font.Name := 'Segoe UI';
    tmsfncCostDetails.Appearance.BandLayout.Font.Style := [];
    tmsfncCostDetails.Appearance.ProgressLayout.Format := '%.0f%%';
    tmsfncCostDetails.LeftCol := 1;
    tmsfncCostDetails.ScrollMode := scmItemScrolling;
    tmsfncCostDetails.DesignTimeSampleData := True;
    SetEvent(tmsfncCostDetails, Self, 'OnGetCellLayout', 'tmsfncCostDetailsGetCellLayout');
    SetEvent(tmsfncCostDetails, Self, 'OnCellClick', 'tmsfncCostDetailsCellClick');
    dbaCostDetails.SetParentComponent(tmsfncCostDetails);
    dbaCostDetails.Name := 'dbaCostDetails';
    dbaCostDetails.Left := 372;
    dbaCostDetails.Top := 192;
    dbaCostDetails.Width := 26;
    dbaCostDetails.Height := 26;
    dbaCostDetails.Visible := True;
    dbaCostDetails.Active := True;
    dbaCostDetails.Grid := tmsfncCostDetails;
    dbaCostDetails.DataSource := dsCostDetails;
    dbaCostDetails.Columns.Clear;
    with dbaCostDetails.Columns.Add do
    begin
      FieldName := 'CostGroupMo';
      Header := 'CostGroupMo';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with dbaCostDetails.Columns.Add do
    begin
      FieldName := 'FleetType';
      Header := 'Fleet Type';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with dbaCostDetails.Columns.Add do
    begin
      FieldName := 'ValueType';
      Header := 'Value Types';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with dbaCostDetails.Columns.Add do
    begin
      FieldName := 'SystemType';
      Header := 'System Types';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with dbaCostDetails.Columns.Add do
    begin
      FieldName := 'GLCode';
      Header := ' GL Code';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with dbaCostDetails.Columns.Add do
    begin
      Header := 'Edit';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with dbaCostDetails.Columns.Add do
    begin
      Header := 'Delete';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with dbaCostDetails.Columns.Add do
    begin
      FieldName := 'costgroupsdetail_Auto';
      Header := 'costgroupsdetail_Auto';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    WebMessageDlg1.SetParentComponent(tmsfncCostDetails);
    WebMessageDlg1.Name := 'WebMessageDlg1';
    WebMessageDlg1.Left := 280;
    WebMessageDlg1.Top := 216;
    WebMessageDlg1.Width := 24;
    WebMessageDlg1.Height := 24;
    WebMessageDlg1.Buttons := [];
    WebMessageDlg1.Opacity := 0.200000000000000000;
    wpBottom.SetParentComponent(Self);
    wpBottom.Name := 'wpBottom';
    wpBottom.Left := 0;
    wpBottom.Top := 593;
    wpBottom.Width := 1001;
    wpBottom.Height := 41;
    wpBottom.Align := alBottom;
    wpBottom.BorderStyle := bsNone;
    wpBottom.ChildOrder := 2;
    wpBottom.Color := clSilver;
    wpBottom.TabOrder := 5;
    lPageCountMax.SetParentComponent(wpBottom);
    lPageCountMax.Name := 'lPageCountMax';
    lPageCountMax.Left := 74;
    lPageCountMax.Top := 14;
    lPageCountMax.Width := 15;
    lPageCountMax.Height := 15;
    lPageCountMax.Caption := 'OF';
    lPageCountMax.HeightPercent := 100.000000000000000000;
    lPageCountMax.WidthPercent := 100.000000000000000000;
    btnPageLeft.SetParentComponent(wpBottom);
    btnPageLeft.Name := 'btnPageLeft';
    btnPageLeft.Left := 14;
    btnPageLeft.Top := 6;
    btnPageLeft.Width := 26;
    btnPageLeft.Height := 26;
    btnPageLeft.Color := clNone;
    btnPageLeft.GlyphURL := 'images/buttons/prior.svg';
    btnPageLeft.GlyphSize := 20;
    btnPageLeft.HeightPercent := 100.000000000000000000;
    btnPageLeft.TabOrder := 0;
    btnPageLeft.WidthPercent := 100.000000000000000000;
    SetEvent(btnPageLeft, Self, 'OnClick', 'btnPageLeftClick');
    btnPageRight.SetParentComponent(wpBottom);
    btnPageRight.Name := 'btnPageRight';
    btnPageRight.Left := 120;
    btnPageRight.Top := 8;
    btnPageRight.Width := 26;
    btnPageRight.Height := 26;
    btnPageRight.Color := clNone;
    btnPageRight.GlyphURL := 'images/buttons/next.svg';
    btnPageRight.GlyphSize := 20;
    btnPageRight.HeightPercent := 100.000000000000000000;
    btnPageRight.TabOrder := 1;
    btnPageRight.WidthPercent := 100.000000000000000000;
    SetEvent(btnPageRight, Self, 'OnClick', 'btnPageRightClick');
    ePageCount.SetParentComponent(wpBottom);
    ePageCount.Name := 'ePageCount';
    ePageCount.Left := 46;
    ePageCount.Top := 9;
    ePageCount.Width := 25;
    ePageCount.Height := 24;
    ePageCount.Alignment := taCenter;
    ePageCount.ChildOrder := 2;
    ePageCount.EditType := weNumeric;
    ePageCount.HeightPercent := 100.000000000000000000;
    ePageCount.Text := '1';
    ePageCount.WidthPercent := 100.000000000000000000;
    SetEvent(ePageCount, Self, 'OnExit', 'ePageCountExit');
    eMaxPageCount.SetParentComponent(wpBottom);
    eMaxPageCount.Name := 'eMaxPageCount';
    eMaxPageCount.Left := 92;
    eMaxPageCount.Top := 9;
    eMaxPageCount.Width := 25;
    eMaxPageCount.Height := 24;
    eMaxPageCount.Alignment := taCenter;
    eMaxPageCount.ChildOrder := 2;
    eMaxPageCount.EditType := weNumeric;
    eMaxPageCount.HeightPercent := 100.000000000000000000;
    eMaxPageCount.ReadOnly := True;
    eMaxPageCount.WidthPercent := 100.000000000000000000;
    wdsCostGroups.SetParentComponent(Self);
    wdsCostGroups.Name := 'wdsCostGroups';
    wdsCostGroups.EntitySetName := 'costgroups';
    wdsCostGroups.Connection := dmData.dbConnect;
    wdsCostGroups.Left := 112;
    wdsCostGroups.Top := 17;
    wdsCostGroupsCode.SetParentComponent(wdsCostGroups);
    wdsCostGroupsCode.Name := 'wdsCostGroupsCode';
    wdsCostGroupsCode.FieldName := 'Code';
    wdsCostGroupsSuspended.SetParentComponent(wdsCostGroups);
    wdsCostGroupsSuspended.Name := 'wdsCostGroupsSuspended';
    wdsCostGroupsSuspended.FieldName := 'Suspended';
    wdsCostGroupsDescription.SetParentComponent(wdsCostGroups);
    wdsCostGroupsDescription.Name := 'wdsCostGroupsDescription';
    wdsCostGroupsDescription.FieldKind := fkCalculated;
    wdsCostGroupsDescription.FieldName := 'Description';
    wdsCostGroupsDescription.Calculated := True;
    dsCostGroups.SetParentComponent(Self);
    dsCostGroups.Name := 'dsCostGroups';
    dsCostGroups.DataSet := wdsCostGroups;
    dsCostGroups.Left := 184;
    dsCostGroups.Top := 17;
    wdsCostDetails.SetParentComponent(Self);
    wdsCostDetails.Name := 'wdsCostDetails';
    wdsCostDetails.Connection := dmData.dbConnect;
    wdsCostDetails.Left := 296;
    wdsCostDetails.Top := 367;
    wdsCostDetailsCostGroupMo.SetParentComponent(wdsCostDetails);
    wdsCostDetailsCostGroupMo.Name := 'wdsCostDetailsCostGroupMo';
    wdsCostDetailsCostGroupMo.FieldName := 'CostGroupMo';
    wdsCostDetailsFleetType.SetParentComponent(wdsCostDetails);
    wdsCostDetailsFleetType.Name := 'wdsCostDetailsFleetType';
    wdsCostDetailsFleetType.FieldName := 'FleetType';
    wdsCostDetailsValueType.SetParentComponent(wdsCostDetails);
    wdsCostDetailsValueType.Name := 'wdsCostDetailsValueType';
    wdsCostDetailsValueType.FieldName := 'ValueType';
    wdsCostDetailsSystemType.SetParentComponent(wdsCostDetails);
    wdsCostDetailsSystemType.Name := 'wdsCostDetailsSystemType';
    wdsCostDetailsSystemType.FieldName := 'SystemType';
    wdsCostDetailsGLCode.SetParentComponent(wdsCostDetails);
    wdsCostDetailsGLCode.Name := 'wdsCostDetailsGLCode';
    wdsCostDetailsGLCode.FieldName := 'GLCode';
    wdsCostDetailscostgroupsdetail_Auto.SetParentComponent(wdsCostDetails);
    wdsCostDetailscostgroupsdetail_Auto.Name := 'wdsCostDetailscostgroupsdetail_Auto';
    wdsCostDetailscostgroupsdetail_Auto.FieldName := 'costgroupsdetail_Auto';
    dsCostDetails.SetParentComponent(Self);
    dsCostDetails.Name := 'dsCostDetails';
    dsCostDetails.AutoEdit := False;
    dsCostDetails.DataSet := wdsCostDetails;
    dsCostDetails.Left := 376;
    dsCostDetails.Top := 368;
    wcCostingDetails.SetParentComponent(Self);
    wcCostingDetails.Name := 'wcCostingDetails';
    wcCostingDetails.Connection := dmData.dbConnect;
    wcCostingDetails.Left := 200;
    wcCostingDetails.Top := 368;
    wcCostGroups.SetParentComponent(Self);
    wcCostGroups.Name := 'wcCostGroups';
    wcCostGroups.Connection := dmData.dbConnect;
    wcCostGroups.Left := 40;
    wcCostGroups.Top := 8;
    wcPageCount.SetParentComponent(Self);
    wcPageCount.Name := 'wcPageCount';
    wcPageCount.Connection := dmData.dbConnect;
    wcPageCount.Left := 200;
    wcPageCount.Top := 488;
  finally
    WebPanel5.AfterLoadDFMValues;
    wsbtnPost.AfterLoadDFMValues;
    wsbtnClose.AfterLoadDFMValues;
    WebPanel4.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    dbedtCostGrooup.AfterLoadDFMValues;
    dbcbxSuspended.AfterLoadDFMValues;
    pnlButtons.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    WebSpeedButton3.AfterLoadDFMValues;
    WebSpeedButton4.AfterLoadDFMValues;
    WebSpeedButton5.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    tmsfncCostDetails.AfterLoadDFMValues;
    dbaCostDetails.AfterLoadDFMValues;
    WebMessageDlg1.AfterLoadDFMValues;
    wpBottom.AfterLoadDFMValues;
    lPageCountMax.AfterLoadDFMValues;
    btnPageLeft.AfterLoadDFMValues;
    btnPageRight.AfterLoadDFMValues;
    ePageCount.AfterLoadDFMValues;
    eMaxPageCount.AfterLoadDFMValues;
    wdsCostGroups.AfterLoadDFMValues;
    wdsCostGroupsCode.AfterLoadDFMValues;
    wdsCostGroupsSuspended.AfterLoadDFMValues;
    wdsCostGroupsDescription.AfterLoadDFMValues;
    dsCostGroups.AfterLoadDFMValues;
    wdsCostDetails.AfterLoadDFMValues;
    wdsCostDetailsCostGroupMo.AfterLoadDFMValues;
    wdsCostDetailsFleetType.AfterLoadDFMValues;
    wdsCostDetailsValueType.AfterLoadDFMValues;
    wdsCostDetailsSystemType.AfterLoadDFMValues;
    wdsCostDetailsGLCode.AfterLoadDFMValues;
    wdsCostDetailscostgroupsdetail_Auto.AfterLoadDFMValues;
    dsCostDetails.AfterLoadDFMValues;
    wcCostingDetails.AfterLoadDFMValues;
    wcCostGroups.AfterLoadDFMValues;
    wcPageCount.AfterLoadDFMValues;
  end;
end;

end.
